import React from 'react';
import Button from '@mui/material/Button';

import { hasDesignValuesEditPermission, isUsingCustomTheme } from '@paragon/login-tools';
import { ParagonHeader } from '@paragon/material';
import { UserDropdown } from '@paragon/themes';

import materialsLogoUrl from '../../../resources/materials.png';
import { useAppSelector } from '../hooks';

export function Header() {
  const usingCustomTheme = useAppSelector(isUsingCustomTheme);
  const renderHeaderText = (usingCustomTheme && `Materials`) || 'Paragon Materials';

  return (
    <ParagonHeader clientLogoUrl={materialsLogoUrl} text={renderHeaderText} clientName="paragon-materials">
      <EditPlateGripValuesButton />
      <UserDropdown hideThemeToggleButton sx={{ color: '#fff' }} />
    </ParagonHeader>
  );
}

function EditPlateGripValuesButton() {
  const canEditGripValues = useAppSelector(hasDesignValuesEditPermission);
  if (!canEditGripValues) return null;

  return (
    <Button sx={{ backgroundColor: 'primary.main' }} href="/plateGrip">
      customize plate grip values
    </Button>
  );
}
